import apiFetch from '@wordpress/api-fetch';
import { decodeEntities } from '@wordpress/html-entities';

document.addEventListener( 'DOMContentLoaded', () => {
	const blockContainer = document.querySelector(
		'#block-wrapper-artist-workshops'
	); // Adjust to your block's class
	const postId = blockContainer.dataset.artistId;

	if ( ! blockContainer ) return;

	const cardsContainer = document.createElement( 'div' );
	const paginationContainer = document.createElement( 'div' );

	let currentPage = 1;
	let totalPages = 1;
	let isLoading = false;

	cardsContainer.className = 'workshop-cards-container';
	paginationContainer.className = 'pagination-buttons';

	blockContainer.appendChild( cardsContainer );
	blockContainer.appendChild( paginationContainer );

	// Reading the Current Page
	// Extracts the current page from the URL query parameters
	const getPageFromURL = () => {
		const params = new URLSearchParams( window.location.search );
		return parseInt( params.get( 'workshops-page' ), 10 ) || 1;
	};

	// Updating the URL
	// Updates the query parameter when the page changes without reloading
	const updatePageInURL = ( page ) => {
		const params = new URLSearchParams( window.location.search );
		params.set( 'workshops-page', page );
		const newUrl = `${ window.location.pathname }?${ params.toString() }`;
		window.history.pushState( { page }, '', newUrl );
	};

	const createPaginationButtons = () => {
		if ( totalPages <= 1 ) {
			paginationContainer.style.display = 'none'; // Hide pagination
			return;
		} else {
			paginationContainer.style.display = 'block'; // Show pagination
		}

		paginationContainer.innerHTML = '';

		const prevButton = document.createElement( 'button' );
		const nextButton = document.createElement( 'button' );
		const pageInfo = document.createElement( 'span' );

		prevButton.textContent = 'Previous';
		nextButton.textContent = 'Next';
		pageInfo.textContent = `Page ${ currentPage } of ${ totalPages }`;

		prevButton.disabled = currentPage <= 1 || isLoading;
		nextButton.disabled = currentPage >= totalPages || isLoading;

		prevButton.addEventListener( 'click', () =>
			handlePageChange( currentPage - 1 )
		);
		nextButton.addEventListener( 'click', () =>
			handlePageChange( currentPage + 1 )
		);

		paginationContainer.appendChild( prevButton );
		paginationContainer.appendChild( pageInfo );
		paginationContainer.appendChild( nextButton );
	};

	function setPlaceholderVisibility(isVisible = true){
	
		if(	cardsContainer ){
			if(isVisible) {
				cardsContainer.innerHTML = '';
				const requiredCards = 8;
				let count = 0;
				while( count < requiredCards){
					const wrapper = document.createElement("div");
					const title = document.createElement("div");
					const date = document.createElement("div");
					const excerpt = document.createElement("div");
					const category = document.createElement("div");
	
					wrapper.classList.add("card__skeleton");
					title.classList.add("card__skeleton-title");
					date.classList.add("card__skeleton-date");
					excerpt.classList.add("card__skeleton-excerpt");
					category.classList.add("card__skeleton-category");
	
					wrapper.appendChild(title);
					wrapper.appendChild(date);
					wrapper.appendChild(excerpt);
					wrapper.appendChild(category);
	
					cardsContainer.appendChild(wrapper);
					count++;
				}
			} else {
				const skeletons = cardsContainer.querySelectorAll('.card__skeleton');
	
				skeletons.forEach(skeleton => {
					skeleton.style.opacity = '0';
					setTimeout(() => skeleton.remove(), 200);
				});
			}
		}
	}

	const fetchPosts = async ( page = 1 ) => {
		if ( isLoading ) return;
		isLoading = true;

		try {
			const response = await apiFetch( {
				path: `/cnt-plugin/v1/artist-workshops?id=${ postId }&workshops-page=${ page }`,
			} );

			if ( !response || !response.posts || response.posts.length === 0 ) {
				totalPages = 1; // Reset total pages if no posts found
				setPlaceholderVisibility(false);
			} else {
				console.log(response.posts.length);
				setPlaceholderVisibility(false);
				renderPosts( response );
			}

			// Fetch total pages from headers
			const total =
				response && response.posts && response.total_pages
					? response.total_pages
					: 1;
			totalPages = parseInt( total, 10 ) || 1;
			currentPage = page;
		} catch ( error ) {
			console.error( 'Error fetching houses:', error );
			setPlaceholderVisibility(false);

		} finally {
			isLoading = false;
			createPaginationButtons();
		}
	};

	const renderPosts = ( response ) => {

		//  check if user has formation. Otherwise do not display this section
		const sectionTitle = document.getElementById("artist-workshop-title");
		sectionTitle.style.display = "flex";

		cardsContainer.innerHTML = '';

		response?.posts.forEach( ( post ) => {
			const thumbnailId = post.featured_image || '';
			const shortDescr =
				decodeEntities( post.excerpt ) || '';
			const taxonomies = post._embedded?.[ 'wp:term' ]?.[ 0 ] || [];
			const postTitle = post.title.length > 1 ? decodeEntities( post.title ) : "Sans titre";

			const card = document.createElement( 'div' );
			card.className = 'workshop-card';

			const cardImage = document.createElement( 'div' );
			const cardImageInner = document.createElement( 'div' );

			cardImage.className = 'workshop-card__visual';
			cardImageInner.className = 'workshop-card__visual--inner';

			cardImage.appendChild( cardImageInner );

			const cardContent = document.createElement( 'div' );
			cardContent.className = 'workshop-card-content';

			if ( thumbnailId ) {
				const img = document.createElement( 'img' );
				img.src = thumbnailId;
				img.alt = decodeEntities(post.alt_text);
				img.className = 'workshop-card__visual-tag';
				img.width = '150';
				img.height = '150';
				img.setAttribute("aria-hidden", "true");
				cardImageInner.appendChild( img );
			} else {
				cardImageInner.classList.add(`has-workshop-placeholder`);
			}

			const title = document.createElement( 'h3' );
			const titleLink = document.createElement( 'a' );

			title.className = 'workshop-card-title';

			titleLink.href = post.link;
			titleLink.className = 'workshop-card-link';
			titleLink.textContent = postTitle;

			const description = document.createElement( 'p' );
			description.textContent = shortDescr;

			if ( taxonomies.cnt_w_level_tax ) {
				const levelList = document.createElement( 'p' );
				levelList.className = 'workshop__level-terms';
				levelList.textContent = `Type : ${ taxonomies.cnt_w_level_tax?.join(
					' · '
				) }`;
				cardContent.appendChild( levelList );
			}

			if ( taxonomies.cnt_w_type_tax ) {
				const typeList = document.createElement( 'p' );
				typeList.className = 'workshop__type-terms';
				typeList.textContent = `Type : ${ taxonomies.cnt_w_type_tax?.join(
					'· '
				) }`;
				cardContent.appendChild( typeList );
			}

			title.appendChild( titleLink );
			cardContent.appendChild( title );
			cardContent.appendChild( description );
			if ( taxonomies.length > 0 ) {
				cardContent.appendChild( taxonomyList );
			}

			card.appendChild( cardImage );
			card.appendChild( cardContent );
			cardsContainer.appendChild( card );
		} );
	};

	const handlePageChange = ( page ) => {
		if ( page > 0 && page <= totalPages ) {
			currentPage = page;
			updatePageInURL( page );
			fetchPosts( page );
		}
	};

	// Initialization
	// Load the initial page based on URL
	currentPage = getPageFromURL();
	// Fetch the initial page
	fetchPosts( currentPage );

} );
